import LocationPageIndex from "../../components/Location/LocationPageIndex";
import api from "../../lib/api";

export default function Index({ locations, pagesData, labels }) {
  const header = pagesData.find((page) => page.slug === "locations").header;
  return <LocationPageIndex locations={locations} header={header} labels={labels} />;
}

export async function getStaticProps({ locale }) {
  const data = await api.getDataAndLocalize("/api/collections/map-locations/entries", {
    fields: ["type", "latitude", "longitude"],
    locale,
  });

  const dataSorted = data.sort((a, b) => a.title.localeCompare(b.title));

  return api.injectDefaultData(
    {
      props: {
        locations: dataSorted,
      },
      revalidate: 3,
    },
    locale,
  );
}
